import React from "react";
import Link from "next/link";

import NotFoundIcon from "@/components/Icons/not_found.svg";

type Props = {
  buttonHref: string;
};

const BrandsNearYouEmptyState: React.FC<Props> = ({ buttonHref }) => {
  return (
    <div className="border border-light-grey rounded flex flex-col items-center gap-lg p-lg">
      <div className="flex flex-col items-center gap-md">
        <NotFoundIcon width={48} />
        <h2 className="font-bold text-md text-center">
          No brands found near you
        </h2>
      </div>
      <p className="mb-none text-center">
        Check back later or browse all brands on Leafly
      </p>
      <Link
        href={buttonHref}
        className="button button--secondary w-full md:w-auto"
      >
        browse all brands
      </Link>
    </div>
  );
};

export default BrandsNearYouEmptyState;
